import { ControlSort } from '@trustero/trustero-api-web/lib/model/control_pb'
import { GridColumnSortControls } from '../../../../components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'

export const CONTROL_SORT_COLUMNS = Object.freeze({
  [GridColumnSortControls.NAME]: ControlSort.control_sort_column.NAME,
  [GridColumnSortControls.ID]: ControlSort.control_sort_column.ID,
  [GridColumnSortControls.DEPARTMENT]:
    ControlSort.control_sort_column.DEPARTMENT,
  [GridColumnSortControls.AUTOMATED_EVIDENCE]:
    ControlSort.control_sort_column.AUTOMATED_EVIDENCE,
  [GridColumnSortControls.MANUAL_EVIDENCE]:
    ControlSort.control_sort_column.MANUAL_EVIDENCE,
  [GridColumnSortControls.ASSIGNEE]: ControlSort.control_sort_column.ASSIGNEE,
})

export enum CONTROL_GRID_LOCATIONS {
  CONTROLS_INDEX = 'controls_index_page',
  REQUESTS_SHOW = 'requests_show_page',
  POLICIES_SHOW = 'policies_show_page',
  RECEPTORS_SHOW = 'receptors_show_page',
}
